import { safeJson } from "@/lib/http";
import { supabase } from "@/lib/supabase";

export async function lookupEntreprise(siren) {
    return apiGet(`/api/entreprises/${siren}`);
}

export async function fetchAnalyse(siren, dossierId) {
    return apiGet(`/api/entreprises/${siren}/analyse${dossierId ? `?dossier_id=${dossierId}` : ""}`);
}

export async function fetchProcedures(siren) {
    return apiGet(`/api/entreprises/${siren}/procedures`);
}

export async function fetchEtablissements(siren) {
    return apiGet(`/api/entreprises/${siren}/etablissements`);
}

async function apiGet(path) {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    const body = await safeJson(r);
    if (!r.ok) throw new Error(body.detail || `Erreur ${r.status}`);
    return body;
}
